module.exports = __webpack_public_path__ + "img/PC_04.798e1597.jpg";